<div class="h-100">
    <div class="row d-flex justify-content-center px-2">
        <mat-form-field class="col-12 col-md-4">
            <mat-select placeholder="Type de photo" [(value)]="DocumentType" required>
                <mat-option *ngFor="let d of DocumentTypeList" [value]="d.idx">
                    <span>{{d.s}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-12 col-md-4" *ngIf="DocumentType === EDocumentType.OtherPicture" class="col">
            <mat-label>Description</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" placeholder="Description" [(ngModel)]="Description"></textarea>
        </mat-form-field>
    </div>

    <!-- <app-camera (getPicture)="handleImage($event)"></app-camera>

    <div class="webcam-image" *ngIf="webcamImage">
        <img [src]="webcamImage.imageAsDataUrl" />
    </div> -->

    <div class="row justify-content-center  px-3">
        <!-- <button class="col" mat-raised-button color="accent" (click)="fileInput.click()">
            <input #fileInput type="file" accept="image/*" capture="environment" (change)="changed($event)">
            <mat-icon aria-label="add-image">photo</mat-icon>Prendre une photo
        </button> -->
        <!-- <button class="col-12 col-md-4" mat-raised-button color="accent" (click)="openPhotoView()">
      <mat-icon aria-label="open-photo">photo</mat-icon> Prendre une photo
    </button> -->
        <button appPreventDoubleClick class="col-12 col-md-4" mat-raised-button color="accent" (throttledClick)="goToPictureTaking()" [disabled]="!DocumentType">
            <mat-icon aria-label="photo">photo</mat-icon> Prendre une photo
        </button>
        <div *ngIf="Capture" class="row d-flex justify-content-center">
            <img [src]="Capture" class="p-0" [style.max-width.px]="getThumbnailsSize()" [style.max-height.px]="getMaxHeight()" />
        </div>

    </div>
    <div class="row justify-content-center px-3 mt-2">
        <button appPreventDoubleClick class="col-12 col-md-4" mat-raised-button color="primary" (throttledClick)="savePhoto()" [disabled]="!canSave()">
            <mat-icon aria-label="save">save</mat-icon> Sauvegarder
        </button>
    </div>

</div>